import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";
import type { PatientPool } from "../Models/Domain/PatientsPool";
import type { PatientPoolApi } from "../Models/Api/PatientsPool";

import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

import camelize from "@/Utils/Camelize";

const PatientPoolTransformer: TransformerExtended<PatientPool, PatientPoolApi> = {
  ...DefaultTransformerGenerator<PatientPool, PatientPoolApi>(),

  toDomain(input: PatientPoolApi): PatientPool {
    return camelize<PatientPoolApi>(input) as PatientPool;
  },
};

export type PatientPoolTransformerType = TransformerExtended<PatientPool, PatientPoolApi>;

export default PatientPoolTransformer;
